import { render, staticRenderFns } from "./RoutesReport.vue?vue&type=template&id=678fe1ce&"
import script from "./RoutesReport.vue?vue&type=script&lang=js&"
export * from "./RoutesReport.vue?vue&type=script&lang=js&"
import style0 from "./RoutesReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports